import createNonAttorneyHandler from "./nonAttorneys";
import types from "resources/types";

export default {
  [types.NOT_STARTED_NON_ATTORNEYS]: createNonAttorneyHandler("notStarted"),
  [types.PENDING_NON_ATTORNEYS]: createNonAttorneyHandler("pending"),
  [types.REJECTED_NON_ATTORNEYS]: createNonAttorneyHandler("rejected"),
  [types.VERIFIED_NON_ATTORNEYS]: createNonAttorneyHandler("verified"),
};
